// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: w8Gkq37ZXmVbqHV15DJUBW
// Component: 1En-QsN0bs
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_basil_site_2_0.module.css"; // plasmic-import: w8Gkq37ZXmVbqHV15DJUBW/projectcss
import sty from "./PlasmicSentimentsAnalyzed.module.css"; // plasmic-import: 1En-QsN0bs/css

createPlasmicElementProxy;

export const PlasmicSentimentsAnalyzed__VariantProps = new Array();

export const PlasmicSentimentsAnalyzed__ArgProps = new Array(
  "dataPointsAnalyzed",
  "sentimentsAnalyzed"
);

const $$ = {};

function PlasmicSentimentsAnalyzed__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__jn3Q3)}>
        <div className={classNames(projectcss.all, sty.freeBox__c4Wli)}>
          <div className={classNames(projectcss.all, sty.freeBox__iDn5G)}>
            <div className={classNames(projectcss.all, sty.freeBox__jBlTr)}>
              {renderPlasmicSlot({
                defaultContents: "40k+",
                value: args.dataPointsAnalyzed
              })}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__oibUn
              )}
            >
              {"datapoints analyzed"}
            </div>
          </div>
        </div>
        <div className={classNames(projectcss.all, sty.freeBox__dF5P7)}>
          <div className={classNames(projectcss.all, sty.freeBox__gTKx7)}>
            <div className={classNames(projectcss.all, sty.freeBox__krRj)}>
              {renderPlasmicSlot({
                defaultContents: "10k+",
                value: args.sentimentsAnalyzed
              })}
            </div>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__aYlPy
              )}
            >
              {"sentiments analyzed"}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicSentimentsAnalyzed__ArgProps,
          internalVariantPropNames: PlasmicSentimentsAnalyzed__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicSentimentsAnalyzed__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicSentimentsAnalyzed";
  } else {
    func.displayName = `PlasmicSentimentsAnalyzed.${nodeName}`;
  }
  return func;
}

export const PlasmicSentimentsAnalyzed = Object.assign(
  // Top-level PlasmicSentimentsAnalyzed renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    // Metadata about props expected for PlasmicSentimentsAnalyzed
    internalVariantProps: PlasmicSentimentsAnalyzed__VariantProps,
    internalArgProps: PlasmicSentimentsAnalyzed__ArgProps
  }
);

export default PlasmicSentimentsAnalyzed;
/* prettier-ignore-end */
